module.exports = __webpack_public_path__ + "img/Progress-Report-Inspect-Large.e20e8c94.png";